import 'react-day-picker/dist/style.css';

import { Box, Button, Popover, TextField, TextFieldProps } from '@mui/material';
import dayjs from 'dayjs';
import { useState } from 'react';
import { DateRange, DayPicker } from 'react-day-picker';

const formatRange = (range: DateRange | undefined) => {
  if (!range?.from || !range.to) return '';

  return `${dayjs(range.from).format('MMM D, YYYY')} - ${dayjs(range.to).format('MMM D, YYYY')}`;
};

interface DateRangePickerInputProps extends Omit<TextFieldProps, 'onChange' | 'value'> {
  value?: DateRange;
  onChange: (range: DateRange) => void;
  label?: string;
}

const DateRangePickerInput: React.FC<DateRangePickerInputProps> = ({
  label,
  onChange,
  value,
  ...textFieldProps
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [selectedRange, setSelectedRange] = useState<DateRange | undefined>(value);

  const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleApply = () => {
    if (selectedRange?.from && selectedRange?.to) {
      onChange(selectedRange);
      setAnchorEl(null);
    }
  };

  return (
    <>
      <TextField
        fullWidth
        inputProps={{ readOnly: true }}
        label={label}
        onClick={handleOpen}
        value={formatRange(selectedRange)}
        {...textFieldProps}
      />

      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        onClose={() => setAnchorEl(null)}
        open={!!anchorEl}
      >
        <Box sx={{ p: 2 }}>
          <DayPicker
            mode="range"
            numberOfMonths={2}
            onSelect={setSelectedRange}
            selected={selectedRange}
          />

          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button
              disabled={!selectedRange?.from || !selectedRange?.to}
              onClick={handleApply}
              size="small"
              variant="contained"
            >
              Apply
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default DateRangePickerInput;
